import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { SharedModule } from 'app/shared';
import { Invoice } from 'app/shared/service/subscriptions.model';
import { OverlayRef } from 'app/shared/ui/overlays';


@Component({
    selector: 'extra-credits',
    imports: [
        CurrencyPipe,
        DatePipe,
        SharedModule,
    ],
    template: `
        <ui-modal size="md">
            <modal-header>
                Billing History
            </modal-header>
            <modal-body class="p-4">
                <div class="row">
                    <div class="col">
                        @for (invoice of invoices(); track invoice.link) {
                            <div>
                                <a [href]="invoice.link" target="_blank">
                                    {{ invoice.date * 1000 | date:'longDate' }} ({{ invoice.amount | currency:'CAD':'symbol-narrow':'1.0-3' }})
                                </a>
                            </div>
                        }
                    </div>
                </div>
            </modal-body>
            <modal-footer class="border-top-0">
                <button class="btn btn-link mr-auto" (click)="close()">
                    Back
                </button>
            </modal-footer>
        </ui-modal>
    `,
})
export class BillingHistoryModalComponent {

    invoices = input<Invoice[]>([]);

    private overlayRef = inject(OverlayRef);

    close(value = null) {
        this.overlayRef.close(value);
    }
}
